// assets/a24-cookie-banner.js
(function () {
  'use strict';

  function initCookieBanner() {
    // Zeigt den Cookie-Hinweis nur, solange keine Auswahl gespeichert ist.
    var banner = document.getElementById('cookie-banner');
    if (!banner || banner.dataset.a24CookieBannerReady === 'true') return;
    banner.dataset.a24CookieBannerReady = 'true';

    if (!window.localStorage.getItem('cookie_consent')) {
      banner.hidden = false;
    }

    function hideBanner(type) {
      // Persistiert die Auswahl und blendet den Banner aus.
      window.localStorage.setItem('cookie_consent', type);
      banner.hidden = true;
    }

    var btnAll = document.getElementById('cookie-accept-all');
    var btnEss = document.getElementById('cookie-accept-essential');
    if (btnAll) btnAll.addEventListener('click', function () { hideBanner('all'); });
    if (btnEss) btnEss.addEventListener('click', function () { hideBanner('essential'); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieBanner, { once: true });
  } else {
    initCookieBanner();
  }
})();
